import { SVGIconComponent } from './types';

export const EventDoor: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ color, ...style }}
    className={className}
  >
    <g id="timeline/event-door-opened" stroke="none" fill="none" fillRule="evenodd">
      <path
        d="M5.47396578,3.00000172 C5.22162677,2.99913446 5.00018193,3.3264395 5.00018193,3.61118206 L5.00018193,18.6475095 C5.00018193,18.9730566 5.28857879,19.1015597 5.58383125,19.2309073 C8.43264291,20.4784451 14.1326833,22.9744315 14.1326833,22.9744315 C14.4279577,23.1037857 14.709477,22.7165808 14.709477,22.3910337 L14.709477,19.2586882 L17.1539837,19.2586882 C18.2277429,19.2586882 19.117829,18.3653673 19.117829,17.279314 L19.117829,4.99329028 C19.117829,3.90723699 18.2277429,3.00695977 17.1539837,3.00695977 C16.2304326,3.00695977 9.36803752,3.00348605 5.47396578,3.00000172 L5.47396578,3.00000172 Z M8.49526622,4.29876912 L17.1539837,4.29876912 C17.5427976,4.29876912 17.8406429,4.60002462 17.8406429,4.99329028 L17.8406429,17.279314 C17.8406429,17.6725796 17.5427976,17.966901 17.1539837,17.966901 L14.709477,17.966901 L14.709477,7.35461776 C14.709477,7.02907069 14.4279577,6.90056761 14.1326833,6.77121999 L8.49526622,4.29876912 Z"
        id="icon-open-locker"
        fill="currentColor"
      ></path>
    </g>
  </svg>
);
